<div class="grid grid-cols-w-24 p-2 gap-2 border border-neutral-2 rounded max-h-40 overflow-y-scroll">
  @for (photo of photos; track photo) {
    <div class="aspect-square relative group cursor-pointer" (click)="toggleSelected(photo)">
      <app-photo [photo]="photo" class="w-full h-full"></app-photo>
      <div class="absolute h-2/4 left-0 right-0 bottom-0 from-imageGradient to-imageGradient-1 bg-gradient-to-t">
      </div>
      <div class="absolute bottom-1 left-1 w-5 h-5 group-hover:bg-neutral-4 rounded border border-neutral-2 flex justify-center items-center"
        [ngClass]="selectedPhotoIds.includes(photo.id) ? 'bg-primary border-primary' : 'bg-white'">
        <img src="/assets/icons/checkbox.svg">
      </div>
    </div>
  }
</div>
